<template>
    <el-dialog :title="isEdit?'编辑邮件模板':'创建邮件模板'" :visible.sync="showDialog">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" :key="preventKey" :label-width="labelWidth"
                 class="form-beauty">
            <el-form-item label="模板名称:" prop="name" required>
                <el-input
                        :maxlength="50"
                        placeholder="请输入模板名称"
                        v-model.trim="ruleForm.name">
                </el-input>
            </el-form-item>
            <el-form-item label="邮件标题:" prop="title" required>
                <el-input :maxlength="100"
                          placeholder="请输入邮件标题"
                          v-model.trim="ruleForm.title">
                </el-input>
            </el-form-item>
            <el-form-item label="招聘阶段:" prop="phase" required>
                <el-select @change="getMailHolder(true)" v-model="ruleForm.phase" placeholder="请选择">
                    <el-option v-for="(item, key) in selectMap.WB_PHASE" :key="key"
                               :label="item.text" :value="String(item.value)"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="用户类型:" prop="userAttributes" required>
                <el-select @change="getMailHolder(true)" v-model="ruleForm.userAttributes" placeholder="请选择">
                    <el-option v-for="(item, key) in selectMap.WB_USER_ATTRIBUTES" :key="key"
                               :label="item.text" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否可用:" prop="visible" required>
                <el-radio-group v-model="ruleForm.visible">
                    <el-radio label="0">不可用</el-radio>
                    <el-radio label="1">可用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否私有:" prop="isPrivate" required>
                <el-radio-group v-model="ruleForm.isPrivate">
                    <el-radio label="0">否</el-radio>
                    <el-radio label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="邮件内容:" prop="content">
                <div class="el-tag-operation" v-if="mailHolders.length">
                    <el-tag class="mr-5" v-for="(item, index) in mailHolders" :key="index"
                            @click.native="$refs.editor.addAfterCursor(item.value)">{{item.text}}
                    </el-tag>
                </div>
                <vueditor v-model="ruleForm.content" ref="editor"></vueditor>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="showDialog = false">取消</el-button>
            <el-button type="primary" @click="saveDate('ruleForm')">确定</el-button>
        </div>
    </el-dialog>
</template>
<script type="text/javascript">
    import selectMapMixin from 'mixins/selectMapMixin'
    import Vueditor from 'components/vueditor'

    const Model = {
        id: null,
        userAttributes: '',
        phase: '',
        title: '',
        visible: '1',
        isPrivate: '0',
        name: '',
        content: ''
    }

    export default {
        mixins: [selectMapMixin],
        data () {
            return {
                showDialog: false,
                ruleForm: Object.assign({}, Model),
                attachList: [],
                mailHolders: [],
                preventKey: 1,
                rules: {
                    name: [{required: true, message: '请输入', trigger: 'blur'}],
                    title: [{required: true, message: '请输入', trigger: 'blur'}],
                    content: [{required: true, message: '请输入', trigger: 'blur'}],
                    userAttributes: [{required: true, message: '请选择', trigger: 'blur,change'}],
                    phase: [{required: true, message: '请选择', trigger: 'blur,change'}],
                    visible: [{required: true, message: '请选择', trigger: 'blur,change'}],
                    isPrivate: [{required: true, message: '请选择', trigger: 'blur,change'}]
                },
                labelWidth: '120px',
                editUrl: '/system/mailTemplate/update.api',
                addUrl: '/system/mailTemplate/insert.api'
            }
        },
        computed: {
            isEdit () {
                return !!this.ruleForm.id
            }
        },
        methods: {
            show (data) {
                this.preventKey = +new Date()
                Object.assign(this.ruleForm, Model)
                if (data) {
                    for (let attr in Model) {
                        this.ruleForm[attr] = typeof data[attr] === 'number' ? data[attr] + '' : data[attr]
                    }
                    this.getMailHolder(false)
                } else {
                    this.mailHolders = []
                }
                this.showDialog = true
            },
            saveDate (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.post(this.isEdit ? this.editUrl : this.addUrl, Object.assign({}, this.ruleForm), {'X-showMessage': true}).then(res => {
                            this.showDialog = false
                            this.$emit('reloadList')
                        }).catch(() => {})
                    } else {
                        return false
                    }
                })
            },
            getMailHolder (needResetContent) {
                const { phase, userAttributes } = this.ruleForm
                if (phase && userAttributes) {
                    this.$axios.get('/system/mailTemplate/getMailHolder.api', {
                        params: {
                            phase,
                            userAttributes
                        }
                    }).then(res => {
                        if (needResetContent && this.$refs.editor) {
                            this.$refs.editor.resetContent('')
                        }

                        this.mailHolders = res.result.list || []
                    })
                }
            }
        },
        components: {
            Vueditor
        }
    }
</script>
<style type="text/css" lang="scss">

</style>


// WEBPACK FOOTER //
// editEmailTpl.vue?bab80b7a